export default __webpack_public_path__ + "static/media/can-do.6c4f0396.svg";